'use client';
import BenefitsFilter from '@/components/BenefitsFilter';
import PageHeader from '@/components/PageHeader';

import CardGrid from '@/components/CardGrid';
import GuideUtua from '@/components/GuideUtua';
import List from '@/img/list.svg';
import MoneyBag from '@/img/money_bag.svg';
import Money from '@/img/orange_money.svg';
import { mapLoansData } from '@/mappers/FinancialInstitution';
import { Loan } from '@/types/loan';
import { RequestErrorResponse } from '@/utils/request';

import { truncateText } from '@/utils/charactersLimit';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import ErrorState from '../ErrorState';

interface LoanPageProps {
  loanData: Loan[] | RequestErrorResponse;
}
export default function LoanPageComponent({ loanData }: LoanPageProps) {
  const [error, setError] = useState<boolean>(false);
  const [unifiedData, setUnifiedData] = useState([]);
  const t = useTranslations('Index');

  useEffect(() => {
    if ('error' in loanData) {
      setError(true);
    } else {
      const filteredLoans = loanData
        .sort(() => Math.random() - 0.5)
        .slice(0, 4);
      const unified = mapLoansData(filteredLoans, 'primary', 'loans.moreInfo');
      setUnifiedData(unified);
    }
  }, [loanData]);

  const renderCardGrid = () => {
    if (error) return <ErrorState />;

    return (
      <CardGrid
        title={t('cardGrid.loan.title')}
        cards={unifiedData}
        pageType="LoanPage"
      />
    );
  };

  return (
    <>
      <PageHeader
        subtitle={t('pageHeader.loan.subtitle')}
        title={t('pageHeader.loan.title')}
        bgColor="dark"
      />
      <BenefitsFilter
        title={t('benefitsFilter.loan.title')}
        cards={[
          {
            image: MoneyBag,
            text: t.markup('loanTypes.first', {
              strong: (text) => `<strong>${text}</strong>`,
            }),
            linkToFilter: `/emprestimo/todos`,
            queryParams: `loanType=${t('loanTypes.first')}`,
          },
          {
            image: Money,
            text: truncateText(
              t.markup('loanTypes.second', {
                strong: (text) => `<strong>${text}</strong>`,
              }),
              40
            ),
            linkToFilter: `/emprestimo/todos`,
            queryParams: `loanType=${t('loanTypes.second')}`,
          },
        ]}
        linkButtonAll="/emprestimo/todos"
        textButton={t.markup('benefitsFilter.loan.textButton', {
          strong: (text) => `<strong>${text}</strong>`,
        })}
        cardFilterIcon={List}
      />
      {renderCardGrid()}
      <GuideUtua
        title={t('guideUtua.title')}
        placeholder={t('guideUtua.placeholder')}
      />
    </>
  );
}
